module.exports = "<!--\r\n  preserveAspectRatio of xMidYMid meet as the center of the viewport is the circle's\r\n  center. The center of the circle will remain at the center of the md-progress-spinner\r\n  element containing the SVG.\r\n-->\r\n<svg viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid meet\">\r\n  <path></path>\r\n</svg>"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/progressbars/progress-spinner-module/progress-spinner.component.html
// module id = ../../../../../src/libs/mdbootstrap/typescripts/pro/progressbars/progress-spinner-module/progress-spinner.component.html
// module chunks = main